
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface NavbarLogoProps {
  isMobile: boolean;
}

export function NavbarLogo({ isMobile }: NavbarLogoProps) {
  return (
    <Link to="/" className="h-12">
      <img 
        src="/lovable-uploads/87a5dde7-1936-427d-9445-a04a0a26820b.png" 
        alt="Safelight" 
        className="h-full"
      />
    </Link>
  );
}
